import { Check } from "@material-ui/icons";

const StyledBulletList = ({
  bulletList,
  bulletColor = "light-blue",
  tickColor = "primary",
  className = "",
}) => {
  return (
    <div className={`styled-bullet-list mt-4 ${className}`}>
      {bulletList.map((item, index) => {
        return (
          <div key={index} className="d-flex pb-2">
            <div className="pe-2">
              <span
                className={`bullet-point rounded-circle bg-${bulletColor} text-${tickColor}`}>
                <Check />
              </span>
            </div>
            <span>{item}</span>
          </div>
        );
      })}
    </div>
  );
};

export default StyledBulletList;
